const Social: React.FC = () => {
  return (
    <div className="social">
      <a target="_blank" href="https://github.com/agentdmitro" className="social__link">
        <img src="./img/icons/github.png" alt="github" />
      </a>
      <a target="_blank" href="https://t.me/agentdmitro" className="social__link">
        <img src="./img/icons/telegram.svg" alt="telegram" />
      </a>
      <a target="_blank" href="https://www.instagram.com/agentdmitro/" className="social__link">
        <img src="./img/icons/instagram.svg" alt="instagram" />
      </a>
      <a target="_blank" href="https://twitter.com/agentdmitro1337" className="social__link">
        <img src="./img/icons/twitter.svg" alt="twitter" />
      </a>
      <a target="_blank" href="mailto:agentdmitro@gmail.com" className="social__link">
        <img src="./img/icons/mail.svg" alt="mail" />
      </a>
    </div>
  );
};
export default Social;
